<template>
  <div class="pb-4">
    <div v-for="(item, index) in values">
      <div class="col-md-12 pl-5">
        <div class="row">
          <div class="col-md-12">
            <div class="form-check">
              <input
              type="checkbox"
              class="form-check-input"
              value="1"
              v-model="item.checked"
              :id="'option' + item.id"
              />
              <label :for="'option' + item.id">{{ item.text }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showButtons: Boolean,
    immediateWatch: false,
    value: ""
  },
  data() {
    return {
      values: []
    };
  },
  created() {
    // usado desta forma para conseguir mostrar os valores no edit. Adicionado immediate: true para mostrar, no add esta como false.
    this.$watch('value', (newData) => {
      this.values = newData;
    },
    { 
      immediate: this.immediateWatch
    })
  },
  // watch: {
  //   value: {
  //     handler(newData) {
  //       this.values = newData;
  //     },
  //     immediate: true,
  //   }
  // },
};
</script>
<style>
</style>
